import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import '../css/bootstrap-social.css'
import '../css/register.css'
import Cookies from 'universal-cookie';


const cookies = new Cookies();
function Register() {
    document.body.style.backgroundColor = "white"
    const navigate = useNavigate();
    const [regisMessage, setRegisMessage] = useState("");
    const [toggle, setToggle] = useState(false);
    const [verifyOtp, setVerifyOtp] = useState(false);
    const [err, setErr] = useState("");
    const [otp, setOtp] = useState("");
    const [showotpPage, setShowotpPage] = useState({});
    const [disable, setDisable] = useState(false);
    const [form, setForm] = useState({
        firstname: "",
        lastname: "",
        username: "",
        email: "",
        password: ""
    });

    const handleChange = async (e) => {
        setErr("");
        const { name, value } = e.target;
        setForm(prev => {
            return { ...prev, [name]: value }
        })
    }

    function handleClick() {

        if (form.firstname === "" || form.lastname === "" || form.username === "" || form.email === "" || form.password === "") {
            setErr("All fields are required.");
            return;
        }
        setDisable(true);
        const email = form.email;
        if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
            setErr("Invalid Email.");
            return;
        }
        axios.post("https://newchatapp-mn65.onrender.com/email", { email: form.email, username: form.username })
            .then((res) => {
                // console.log(res.data);
                setShowotpPage(res.data);
                setDisable(false);
                setToggle(!toggle);
            })

    }

    useEffect(() => {
        if (showotpPage.message != "User can be verified with email otp.") {
            setErr(showotpPage.message);
        }
    }, [toggle]);


    useEffect(() => {
        if (showotpPage.success) {
            setVerifyOtp(true);
            setTimeout(() => { setVerifyOtp(false) }, 300000);
        } else {
            setErr(showotpPage.message);
        }
    }, [showotpPage.success])


    function handleClk() {
        axios.post("https://newchatapp-mn65.onrender.com/otp", { otp })
            .then((res) => {
                if (res.data.success) {
                    const user = {
                        firstname: form.firstname,
                        lastname: form.lastname,
                        username: form.username,
                        email: form.email,
                        password: form.password
                    }
                    axios.post("https://newchatapp-mn65.onrender.com/regisdata", user)
                        .then((res) => {
                            // console.log(res.data);
                            var date = new Date();
                            date.setDate(date.getDate() + 3);
                            if (res.data.token) cookies.set('token', res.data.token, { path: '/', expires: date, sameSite: true });
                            setRegisMessage(res.data.message);
                        })
                } else {
                    // console.log(res.data);
                    setErr("Wrong OTP")
                }
            })
    }

    useEffect(() => {
        if (regisMessage === "Your account successflully created.") {
            navigate("../home", { replace: true });
        }
    }, [regisMessage])

    function googleAuth() {
        window.open("https://newchatapp-mn65.onrender.com/googleauth", "_self");
    }
    function gitHubAuth() {
        window.open("https://newchatapp-mn65.onrender.com/githubauth", "_self");
    }
    if (verifyOtp) {
        return (
            <div className="otpdiv">
                <div className="innerotpdiv">
                    <p>please check Email for OTP</p>
                    <p>OTP valid for 5 minutes</p>
                    <input autoFocus={true} onChange={(e) => { setErr(""); setOtp(e.target.value) }} type="text" value={otp} placeholder='Enter OTP' />
                    <button onClick={handleClk} className='sbtotp'>Submit</button>
                    {err && <p className='regiserr'>{err} </p>}
                </div>
            </div>
        )
    } else {


        return (
            <div className='register'>
                <h2>ChatApp</h2>
                <div className="registerform">
                    <div className="firstlast">
                        <div className="namediv">
                            <label className='regisLabel' htmlFor="Firstname">First Name</label>
                            <input onKeyDown={(e)=>{if(e.keyCode===13){handleClick()}}} onChange={handleChange} name="firstname" value={form.firstname} className='regisInput' title="This field is required" autoFocus={true} id='Firstname' type="text" />
                        </div>
                        <div className="surnamediv">
                            <label className='regisLabel' htmlFor="Lastname">Last Name</label>
                            <input onKeyDown={(e)=>{if(e.keyCode===13){handleClick()}}} onChange={handleChange} name="lastname" value={form.lastname} className='regisInput' title="This field is required" id='Lastname' type="text" />
                        </div>
                    </div>
                    <label className='regisLabel' htmlFor="username">Username</label>
                    <input onKeyDown={(e)=>{if(e.keyCode===13){handleClick()}}} onChange={handleChange} className='regisInput' name="username" value={form.username} title="Prefer AlphaNumeric username" id='username' type="text" />
                    <label className='regisLabel' htmlFor="email">Email</label>
                    <input onKeyDown={(e)=>{if(e.keyCode===13){handleClick()}}} onChange={handleChange} className='regisInput' name="email" value={form.email} title="Input valid email" id='email' type="email" />
                    <label className='regisLabel' htmlFor="password">Password</label>
                    <input onKeyDown={(e)=>{if(e.keyCode===13){handleClick()}}} onChange={handleChange} className='regisInput' name="password" value={form.password} title="Set unique andl long password" id='password' type="password" />
                    <button disabled={disable} style={{background:disable &&"#8dc8e49c"}} onClick={handleClick} className='btnn'>Register</button>
                    {err && <p className='regiserr'>{err} </p>}
                </div>
                <div className="sociobtns">
                    <button onClick={googleAuth} className='btn btn-social btn-google'><i class="fa-brands fa-google"></i> Google</button>
                    <button onClick={gitHubAuth} className='btn btn-social btn-github'><i class="fa-brands fa-github"></i> Git Hub</button>
                </div>
                Already have login and password? <Link className='linktolog' style={{ textDecoration: "none", fontWeight: "600", margin: "0.6rem 0" }} to="/login">Sign in</Link>
            </div>
        )
    }
}

export default Register

